export function buildAddressString (address) {
  const addressComponents = [
    ['street', 'number'],
    'interiorNumber',
    'colony',
    'city',
    'state'
  ]

  return addressComponents
    .map(addressComponent => {
      const components = [].concat(addressComponent)

      return components
        .map(component => {
          const value = address[component]

          if (component === 'interiorNumber') {
            return value && `Int. ${value}`
          }

          return value
        })
        .filter(component => component)
        .join(' ')
    })
    .filter(addressComponent => addressComponent)
    .join(', ')
}



// WEBPACK FOOTER //
// ./src/screens/App/shared/utils/addresses.js